import styled from "styled-components";
export const H3 = styled.h3`
  ${props => props.theme.fonts.default};
  letter-spacing: ${props => props.theme.headers.h3.letterSpacing};
  font-size: ${props => props.theme.headers.h3.fontSize};
  font-weight: ${props => props.theme.headers.h3.fontWeight};
  line-height: ${props => props.theme.headers.h3.lineHeight};
  text-transform: ${props => props.theme.headers.h3.textTransform};
`;